// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"2955db8a","248":"5ffc725f","525":"d1a18177","654":"d1a18177"}[chunkId] + ".chunk.css";
};